export function paramsToObject(entries: any): {
	[key: string]: string;
} {
	const result: { [key: string]: string } = {};
	for (const [key, value] of entries) {
		const decodedKey = decodeURIComponent(key);
		result[decodedKey] = decodeURIComponent(value);
	}
	return result;
}
